export default "__VITE_ASSET__BJmslI1z__"